<template>
    <div class="panel panel-info">
        <div class="panel-heading"><h4 class="panel-title"><i class="fa fa-book"></i>添加题库</h4></div>
        <div class="panel-body">
            <div class="row">
                <div>
                    <form class="form-horizontal" style="padding-top:10px" id="bs_form">
                        <!--题库名称-->
                        <div class="col-sm-12 ">
                            <div class="form-group">
                                <label class="col-sm-2 control-label"><span class="required" style="margin-right: 5px">*</span>题库名称</label>
                                <div class="col-sm-3">
                                    <input type="text" v-model="model.tkmc" name="tkmc"  v-validate="{required:true,max:50}" class="form-control" data-vv-as="题库名称" placeholder="" />
                                    <span class="error_validate_msg"><em>{{ errors.first('tkmc') }}</em></span>
                                </div>
                            </div>
                        </div>
                        <!--题库课程-->
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="col-sm-2 control-label"><span class="required" style="margin-right: 5px">*</span>题库课程</label>
                                <div class="col-sm-3">
                                    <BootstrapCombobox :data="tkkcList" data-vv-as="课程" name="kcId"  text-field="kcmc" value-field="id" v-model="model.kcId" :format-option="(item)=>(item.kcdm+'-'+item.kcmc)" placeholder="-课程筛选-"></BootstrapCombobox>
                                    <span class="error_validate_msg"><em>{{ errors.first('kcId') }}</em></span>
                                </div>
                            </div>
                        </div>
                        <!--题库图标-->
                        <div class="col-sm-12 ">
                            <div class="form-group">
                                <label class="col-sm-2 control-label">题库图标</label>
                                <div class="col-sm-3" style="text-align: left">
                                    <image-upload v-model="model.tktb"></image-upload>
                                </div>
                            </div>
                        </div>
                        <!--状态-->
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="col-sm-2 control-label"><span class="required" style="margin-right: 5px">*</span>状态</label>
                                <div class="col-sm-2">
                                    <select v-model="model.zt" name="zt"  v-validate="{required:true,max:50}" class="form-control " data-vv-as="状态">
                                        <option value="OK">开启</option>
                                        <option value="BLOCK">关闭</option>
                                    </select>
                                    <span class="error_validate_msg"><em>{{ errors.first('zt') }}</em></span>
                                </div>
                                <div class="col-sm-2 control-label"  style="text-align: left">
                                    <span >关闭状态下不允许存取试题</span>
                                </div>
                            </div>
                        </div>
                        <!--题库说明-->
                        <div class="col-sm-12 ">
                            <div class="form-group">
                                <label class="col-sm-2 control-label"><span class="required" style="margin-right: 5px">*</span>题库说明</label>
                                <div class="col-sm-2">
                                    <input name="tksm" v-model="model.tksm" v-validate="{required:true,max:50}" type="text"  data-vv-as="题库说明"  placeholder=""  class="form-control">
                                    <span class="error_validate_msg"><em>{{ errors.first('tksm') }}</em></span>
                                </div>
                            </div>
                        </div>
                        <!--按钮-->
                        <div class="col-sm-12" >
                            <div class="form-group">
                                <div class="col-sm-3">
                                    <button @click="save()" type="button" class="btn btn-primary btn-sm pull-right" style="padding-left: 20px;padding-right: 20px;"><i class="" aria-hidden="true"></i>提交</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    /**
     * 新增题库
     */

    export default {
        name:"QuesBankAdd",
        components:{
        },
        data:function(){
            return {
                js:this.$store.state.user.js,
                model:{
                    tkmc:'',
                    kcId:'',
                    tktb:'',
                    zt:'OK',
                    tksm:'',
                },
                tkkcList:[]//课程下拉
            }
        },
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'题库管理'},{name:'新增题库'}]);
            this.gettkkcList();//课程下拉
        },
        methods: {
            //课程下拉
            gettkkcList:function(){
                this.$http.post('/htgl/zktk/tk/hqkc').then(res=>{
                    this.tkkcList = res.data;
                });
            },

           //提交
            save:function(){
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
						this.$http.post('/htgl/zktk/tk/xz',this.model).then(res=>{
							if(res.data==true){
								this.$success('操作成功');
							}
						});
                    }
                });
            },
            //取消
            cancel:function(){
                this.$layer.close(this.layerid);
            }
        }

    }
</script>
<style scoped>

</style>
